/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";

export default {
  onBoardVendorInfo: (vid, token) => {
    let url = `/onboarding/vendors/${vid}/${token}`;
    let result = coreApi.GET(url);
    return result;
  },
  onBoardVendorVerify: ({ vid, token, data }) => {
    let url = `/onboarding/vendors/${vid}/${token}`;
    let result = coreApi.PUT(url, data);
    return result;
  },
};
